import {useState, useEffect} from 'react';
import {Box, Typography, Container } from '@mui/material';
import {Accordion, AccordionSummary, AccordionDetails} from '@mui/material'
import { ExpandMore } from '@mui/icons-material';
import { getTopicsQuestions } from '../api/axios';
import QuestionsButton from './QuestionButton';

const MAX_VIEWABLE_QUESTIONS = 4

// TODO: We need a message field for each Topic
export default function TopicCard({topic}) {
    const [expanded, setExpanded] = useState(false)
    const [questionData, setQuestionData] = useState([])

    const slugify = (str) => {
        return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')
    }

    useEffect(() => {
        const fetchTopicQuestions = async () => {
            try {
                const response = await getTopicsQuestions(topic.name)
                setQuestionData(response.data)
            } catch (error) {
                console.error(`Error getting topics: ${error}`)
            }
        }
        fetchTopicQuestions()
    }, [])
    
    return (
        <Accordion
            data-cy={`topic-accordion-${slugify(topic.name)}`}
            elevation={0}
            expanded={expanded}
            onChange={() => setExpanded(!expanded)}
            sx={{
                width: '95%',
                height: '100%',
                paddingTop: '5%',
                paddingBottom: '5%',
                backgroundColor: 'transparent',
                color: '#302E35',
            }}
        >
            <AccordionSummary expandIcon={<ExpandMore />} sx={{
                width: '100%',
                height: '100%',
                borderTopRightRadius: '35px',
                borderBottomLeftRadius: '35px',
                background: '#E1E1E6',

                "&::before": {
                    content: '""',
                    position: "absolute",
                    inset: 0, // Covers the entire box
                    borderTopRightRadius: '32px',
                    borderBottomLeftRadius: '32px',
                    padding: "3px", // Thickness of the border
                    background: "linear-gradient(316.91deg, #A29EDA -26.21%, #B292D1 -10.9%, #B557AF 38.67%, #6B3A8F 78.77%, #5D2A79 115.46%)", 
            
                    // Masks the inner part, leaving only the border
                    WebkitMask: "linear-gradient(white 0 0) content-box, linear-gradient(white 0 0)",
                    WebkitMaskComposite: "destination-out",
                    maskComposite: "exclude",
            
                    zIndex: 1,
                }
            }}>
                <Box>
                    <Typography><strong>{topic.name}</strong></Typography>
                    <Typography>
                        {topic.description}
                    </Typography>
                </Box>
            </AccordionSummary>
            <AccordionDetails sx={{padding: 0, display: 'flex', flexDirection: 'row'}}>
                <Container sx={{ width: '5%'}}>
                </Container>
                <Container sx={{
                    background: '#211F22',
                    border: '2.5px solid #6B3A8F',
                    borderTopLeftRadius: '20px',
                    borderBottomRightRadius: '35px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    padding: '5%'
                }}>
                    {questionData.slice(0, MAX_VIEWABLE_QUESTIONS).map((question, index) => {
                        return (
                            <QuestionsButton question={question} />
                        )
                    })}
                </Container>
            </AccordionDetails>
        </Accordion>
    );
}